import {
	FAQ_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[FAQ_ROUTE_ID]: {
		// The FAQ is served by the redesign page (RedesignFaqPage) in place at this URL. No legacy modules:
		// the global <RenderModules /> would otherwise render the OLD design below the redesign content.
		// The redesign page owns its own content.
		url: '/FAQ',
		modules: [],
	},
}
